var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delivery_loading"},[_c('div',{staticClass:"delivery_loading_text"},[_vm._v("Please wait…")]),_c('van-loading',{attrs:{"color":_vm.color,"size":"66"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }